import './global.js';
import AppBarba from "./AppBarba";

document.addEventListener('DOMContentLoaded', () => {
    new AppBarba();
});
